/**
 * Build a CMS image URL with an optional width hint for the on-the-fly
 * resize + WebP endpoint at /api/files/*. Only applies to internal
 * (/api/files/) URLs; external URLs (http/https) are passed through.
 *
 * Usage:
 *   assetUrl("/api/files/utsah/uploads/abc.png", 640)  → "https://.../api/files/utsah/uploads/abc.png?w=640"
 *   assetUrl("https://cdn.example/x.jpg")              → passthrough
 *   assetUrl("")                                       → ""
 */
export function assetUrl(u, width) {
  if (!u) return "";
  const full = /^https?:\/\//i.test(u) ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;
  if (!width) return full;
  // Only add resize hint to our own /api/files/ endpoint
  if (!/\/api\/files\//.test(full)) return full;
  const sep = full.includes("?") ? "&" : "?";
  return `${full}${sep}w=${width}`;
}
